// 使用时间转换插件 moment.js
import moment from 'moment'
export function time_format(v) {
  return moment(v).format('YYYY-MM-DD HH:mm:ss');
}
